import classNames from 'classnames';
import React, { useRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';

import InfiniteScroll from 'react-infinite-scroller';
import { logging, logPostInfo } from '../../actions/log';
import { getSpecialListList, getSpecialListTags, getSpecialLoading } from '../../actions/special';
import Loading from '../../components/Loading/Loading';
import ScrollTop from '../../components/ScrollTop/ScrollTop';
import { CONTEXT } from '../../config';
import qs from 'query-string';
import styles from './SpecialList.module.less';
import Select from '../../components/Select/Select';
import nodata from '../../static/special_nodata.png';
import KeepAlive, { useActivate, useUnactivate, useAliveController } from 'react-activation';
import SpecialCard from '../../components/SpecialCard/SpecialCard';
import { userActivate } from 'video-react/lib/actions/player';

const sortList = [
  {
    text: '按时间',
    name: 1,
  },
  {
    text: '浏览量',
    name: 2,
  },
  {
    text: '点赞数',
    name: 3,
  },
];
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectTags = createSelector(
  state => state.special,
  special => special.specialTags,
);
const selectZtList = createSelector(
  state => state.special,
  special => special.specialList,
);
const selectPagenation = createSelector(
  state => state.special,
  special => special.pagenation,
);
function SpecialList() {
  const history = useHistory();
  const location = useLocation();
  const search = qs.parse(location.search) || {};
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const [activePageType, setActivePageType] = useState(null); // 分类
  const [activePageTag, setActivePageTag] = useState(null); // 标签
  const [tagList, setTagList] = useState([]); // 标签展示数据
  const [sortType, setSortType] = useState(
    (search.sort && sortList[search.sort - 1]) || sortList[0],
  );

  const [initTime, setInitTime] = useState(+new Date());
  const [pageTypeParam, setPageTypeParam] = useState(null);

  const classify = useSelector(selectTags) || []; // 分类展示数据
  const ztlist = useSelector(selectZtList);
  const pagenation = useSelector(selectPagenation);
  const [loading, setLoading] = useState(false);
  const monitor = useRef(null); // 是否监视参数变更更新存在tagList activePageType activePageTag
  const [scrollEl, setScrollEl] = useState(null);

  /**
   * 统计页面浏览时长
   */

  const logLeaveTime = () => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Special_List`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  };
  useEffect(() => {
    return () => {
      logLeaveTime();
    };
  }, []);

  useActivate(() => {
    setInitTime(+new Date());
  });

  useUnactivate(() => {
    logLeaveTime();
  });

  // 获取分类页面标签
  useEffect(() => {
    if (!classify || classify.length === 0) {
      dispatch(getSpecialListTags());
    }
  }, []);
  useActivate(() => {
    if (!classify || classify.length === 0) {
      dispatch(getSpecialListTags());
    }
  });

  /**
   * 梳理pageType 获取数据
   */
  const getActiveParam = () => {
    const searchs = qs.parse(window.location.search) || {};
    const pageTypeUrl = searchs.pageType || 'all';
    let pageType = pageTypeUrl;
    if (pageTypeUrl !== 'game') {
      pageType = 'all';
    }
    // 如果
    if (
      pageTypeUrl === 'special' ||
      pageTypeUrl === 'detail' ||
      pageTypeUrl === 'anDetail' ||
      pageTypeUrl === 'recommend'
    ) {
      const ztTypeUrl = searchs.ztType || '';
      if (ztTypeUrl === '') {
        pageType = 'all';
      }
      pageType = ztTypeUrl;
    }
    const resultType = classify.find(item => item.code === pageType) ? pageType : classify[0].code;

    const tempTagClass = classify.find(item => item.code === resultType) || {};
    const tempTagList = tempTagClass.tags || [];

    // 页面注入二级参数
    if (searchs.tag && searchs.tag !== 'undefined') {
      const hasThisTag = tempTagList.find(item => item.tagId === searchs.tag);
      if (hasThisTag) {
        // 二级tag能查找
        setPageTypeParam(resultType);
        setTagList(tempTagList);
        setActivePageType(resultType);
        setActivePageTag(searchs.tag);
      } else {
        // 二级tag不能查找不纯在
        // 循环查找二级参数
        const result = classify.find(level1 => {
          if (level1.tags) {
            const res = level1.tags.find(level2 => level2.tagId === searchs.tag);
            if (res) {
              return level1;
            }
          }
          return null;
        });
        if (result) {
          setPageTypeParam(result.code);
          setActivePageType(result.code);
          setTagList(result.tags);
          setActivePageTag(searchs.tag);
        } else {
          setPageTypeParam(classify[0].code);
          setActivePageType(classify[0].code);
          const tempList = classify[0].tags || [];
          setTagList(tempList);
          setActivePageTag(tempList[0].tagId);
        }
      }
    } else {
      // 页面未注入二级参数
      setActivePageType(resultType);
      setTagList(tempTagList);
      setActivePageTag(tempTagList[0] && tempTagList[0].tagId);
    }
    monitor.current = false;
  };
  /**
   * 梳理pageType 获取数据
   */
  useEffect(() => {
    if (classify && classify.length > 0) {
      getActiveParam();
    }
  }, [classify]);

  // 变更分类选择 重置标签展示数据
  const handelClassify = () => {
    if (activePageType && classify && classify.length > 0 && monitor.current !== false) {
      const targetClassify = classify.find(item => item.code === activePageType) || {};
      setTagList(targetClassify.tags || []);
      const tempTagId =
        targetClassify.tags && targetClassify.tags[0] && targetClassify.tags[0].tagId;
      setActivePageTag(tempTagId);
    }
  };
  useEffect(() => {
    handelClassify();
  }, [activePageType, classify]);

  // 变更分类标签 页面重新请求
  useEffect(() => {
    if (activePageTag && activePageType) {
      const params = {
        code: activePageType,
        tagId: activePageTag,
        sort: sortType.name,
        refresh: true,
        skip: 0,
        limit: 24,
      };
      dispatch(
        getSpecialLoading({
          pagenation: {
            ...params,
            loading: true,
          },
        }),
      );
      dispatch(
        getSpecialListList({
          ...params,
        }),
      );
    }
  }, [activePageTag, activePageType, sortType]);

  // 数据请求发生错误 跳转其他页面
  useEffect(() => {
    if (pagenation.error) {
      dispatch(
        getSpecialLoading({
          pagenation: {
            ...pagenation,
            error: false,
          },
        }),
      );
      history.push(`${CONTEXT}/error`);
    }
  }, [pagenation]);
  // 监听页面首次loading状态
  useEffect(() => {
    setLoading(true);
  }, []);
  userActivate(() => {
    if (history.action === 'PUSH') {
      setLoading(true);
    }
  });
  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
  }, [ztlist, loading]);

  const logPV = () => {
    // PV
    if (pageTypeParam) {
      dispatch(
        logging({
          category: 'P',
          action: 'Special_List',
          label: '',
          param2: {
            source: `Special_List`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            pageType: pageTypeParam,
            tab: pageTypeParam,
          },
        }),
      );
      dispatch(
        logPostInfo({
          source: `Special_List`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        }),
      );
    }
  };
  useEffect(() => {
    logPV();
  }, [dispatch, logInfoData, pageTypeParam]);
  useActivate(() => {
    logPV();
  });

  const handleZtCard = zt => {
    // 点击tab
    dispatch(
      logging({
        category: 'C',
        action: 'Special_List',
        label: '',
        param2: {
          source: `Special_List`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          ztId: zt.ztId,
          tab: activePageType,
          pageType: pageTypeParam,
        },
      }),
    );
    if (zt.ztId) {
      dispatch(
        logPostInfo({
          source_p: `Special_List`,
          source_pp: logInfoData.source_p,
        }),
      );
      history.push(`${CONTEXT}/special?ztId=${zt.ztId}&bizInfo=${zt.bizInfo}`);
    }
  };

  const handleClassify = code => () => {
    // 点击tab
    dispatch(
      logging({
        category: 'C',
        action: 'Special_List_Tab',
        label: '',
        param2: {
          source: `Special_List`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          pageType: pageTypeParam,
          category: code,
          tab: activePageTag,
        },
      }),
    );
    monitor.current = true;
    setActivePageType(code);
  };

  const handleTag = code => () => {
    // 点击tab
    dispatch(
      logging({
        category: 'C',
        action: 'Special_List_Tab',
        label: '',
        param2: {
          source: `Special_List`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          pageType: pageTypeParam,
          category: activePageType,
          tab: code,
        },
      }),
    );
    monitor.current = true;
    setActivePageTag(code);
  };

  const handleSort = value => {
    setSortType(value);
    // setActivePageType('all');
    dispatch(
      logging({
        category: 'C',
        action: 'Special_List_Sort',
        label: '',
        param2: {
          source: `Special_List`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          category: activePageType,
          tab: activePageTag,
          sort: value.name,
        },
      }),
    );
  };

  const loadMore = () => {
    if (pagenation.loading || pagenation.count <= ztlist.length) {
      return;
    }
    dispatch(
      getSpecialLoading({
        pagenation: {
          ...pagenation,
          loading: true,
        },
      }),
    );
    dispatch(
      getSpecialListList({
        code: activePageType,
        tagId: activePageTag,
        sort: sortType.name,
        refresh: false,
        skip: ztlist.length,
        limit: 24,
      }),
    );
  };
  if (loading || (ztlist && ztlist.length === 0 && pagenation.loading)) {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.container} ref={r => setScrollEl(r)}>
      <div className={styles.specialList_container}>
        <div className={styles.specialList_header}>
          <div className={styles.specialList_header_text}>全部专题</div>
          <div className={styles.specialList_header_sort}>
            <Select options={sortList} defaultValue={sortType} handleChange={handleSort} />
          </div>
          <div className={styles.specialList_header_classify}>
            {classify && classify.length > 0 && (
              <div className={classNames(styles.start_grid)}>分类：</div>
            )}
            {classify.map((item, index) => {
              return (
                <div
                  key={`${index}_${item.code}`}
                  className={classNames(styles.common_grid, {
                    [styles.active]: item.code === activePageType,
                  })}
                  onClick={handleClassify(item.code)}
                >
                  {item.name}
                </div>
              );
            })}
          </div>
          <div className={styles.specialList_header_classify}>
            {tagList && tagList.length > 0 && <div className={styles.start_grid}>标签：</div>}
            {tagList.map((item, index) => {
              return (
                <div
                  key={`${index}_${item.tagId}`}
                  className={classNames(styles.common_grid, {
                    [styles.active]: item.tagId === activePageTag,
                  })}
                  onClick={handleTag(item.tagId)}
                >
                  {item.tagName}
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles.specialList_main}>
          {scrollEl &&
            ztlist &&
            ztlist.length > 0 &&
            activePageType === pagenation.code &&
            activePageTag === pagenation.tagId && (
              <InfiniteScroll
                pageStart={1}
                loadMore={loadMore}
                hasMore={(ztlist && ztlist.length) < (pagenation && pagenation.count)}
                loader={
                  <div className={classNames('loader', styles.loader)} key={0}>
                    ----------加载中----------
                  </div>
                }
                initialLoad={false}
                useWindow={false}
                getScrollParent={() => scrollEl}
              >
                <div className={styles.content_column3}>
                  {ztlist.map((item, index) => (
                    <div
                      className={classNames(styles.zt_card)}
                      // onClick={handleZtCard(item)}
                      key={`${index}_${item.ztId}`}
                    >
                      <SpecialCard specialInfo={item} handleClick={handleZtCard} />
                    </div>
                  ))}
                </div>
                {ztlist.length >= pagenation.count && ztlist.length > 12 && (
                  <div className={styles.loader}>----------到底啦----------</div>
                )}
              </InfiniteScroll>
            )}
          {ztlist && ztlist.length === 0 && (
            <>
              <img
                src={nodata}
                alt=""
                className={styles.nodata}
                style={{ marginTop: `${130 - Math.floor(tagList && tagList.length / 10) * 10}px` }}
              />
              <div className={styles.nodata_text}>小编正在疯狂码字，专题内容持续扩充ing…</div>
            </>
          )}
        </div>
        <ScrollTop node={scrollEl} />
      </div>
    </div>
  );
}

export default () => {
  const history = useHistory();
  // const location = useLocation();
  // const id = location.search;
  const { refresh } = useAliveController();
  useEffect(() => {
    if (history.action === 'PUSH') {
      refresh('SpecialList');
    }
  }, []);
  return (
    <KeepAlive name="SpecialList" saveScrollPosition="screen">
      <SpecialList />
    </KeepAlive>
  );
};
